import { create } from 'zustand';
import notificationService from '../services/notificationService';
import { connectSocket, getSocket } from '../config/socket';

const playNotificationSound = () => {
  try {
    const audio = new Audio('/sounds/notification.mp3');
    audio.volume = 0.3;
    audio.play().catch(() => {});
  } catch {}
};

const useNotificationStore = create((set, get) => ({
  notifications: [],
  unreadCount: 0,
  isLoading: false,
  _socketInitialized: false,

  fetchNotifications: async (params = {}) => {
    set({ isLoading: true });
    try {
      const response = await notificationService.getAll(params);
      set({
        notifications: response.data,
        unreadCount: response.meta?.unreadCount || 0,
      });
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
    } finally {
      set({ isLoading: false });
    }
  },

  initSocket: (token) => {
    // Ensure socket exists but don't create duplicate listeners
    if (get()._socketInitialized) return;

    const socket = connectSocket(token);

    socket.on('notification:new', (notification) => {
      const { notifications, unreadCount } = get();
      set({
        notifications: [notification, ...notifications].slice(0, 30),
        unreadCount: unreadCount + 1,
      });
      playNotificationSound();
    });

    set({ _socketInitialized: true });
  },

  cleanupListeners: () => {
    const socket = getSocket();
    if (socket) {
      socket.off('notification:new');
    }
    set({ _socketInitialized: false });
    // NOTE: Do NOT disconnect the socket here — chat uses the same socket
  },

  markAsRead: async (id) => {
    try {
      await notificationService.markAsRead(id);
      const { notifications, unreadCount } = get();
      set({
        notifications: notifications.map((n) =>
          n.id === id ? { ...n, is_read: 1 } : n
        ),
        unreadCount: Math.max(0, unreadCount - 1),
      });
    } catch (error) {
      console.error('Failed to mark as read:', error);
    }
  },

  markAllAsRead: async () => {
    try {
      await notificationService.markAllAsRead();
      const { notifications } = get();
      set({
        notifications: notifications.map((n) => ({ ...n, is_read: 1 })),
        unreadCount: 0,
      });
    } catch (error) {
      console.error('Failed to mark all as read:', error);
    }
  },
}));

export default useNotificationStore;
